import React from 'react';

interface ExtractedData {
    description: string;
    amount: number;
    date: string;
}

interface ReceiptPreviewProps {
    receiptImage: string;
    isProcessing: boolean;
    extractedData: ExtractedData | null;
}

export const ReceiptPreview: React.FC<ReceiptPreviewProps> = ({
    receiptImage,
    isProcessing,
    extractedData
}) => {
    return (
        <>
            {/* Receipt Preview */}
            <div className="receipt-preview">
                <img src={receiptImage} alt="Receipt" className="receipt-image" />
                {isProcessing && (
                    <div className="processing-overlay">
                        <div className="spinner"></div>
                        <div className="processing-text">영수증 분석중...</div>
                    </div>
                )}
            </div>

            {/* Extracted Data */}
            {extractedData && (
                <div className="extracted-data">
                    <div className="data-header">
                        <div className="data-icon">✓</div>
                        <h3 className="data-title">인식 완료!</h3>
                    </div>

                    <div className="data-items">
                        <div className="data-item">
                            <div className="data-label">항목</div>
                            <div className="data-value">{extractedData.description}</div>
                        </div>

                        <div className="data-item">
                            <div className="data-label">금액</div>
                            <div className="data-value amount">{extractedData.amount.toLocaleString('ko-KR')}원</div>
                        </div>

                        <div className="data-item">
                            <div className="data-label">날짜</div>
                            <div className="data-value">{extractedData.date}</div>
                        </div>
                    </div>

                    <div className="data-hint">
                        <div className="hint-icon">💡</div>
                        <div className="hint-text">
                            인식 결과가 정확하지 않다면 다시 촬영해주세요
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
